import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IdbService } from './services/idb.service';
import { PwaService } from './services/pwa.service';
import { Store } from '@ngrx/store';
import { AppState } from './store/root.state';
import { LocalStorageService } from './services/local-storage.service';
import * as userActions from 'src/app/store/user/user.actions';
import { UserDataStringResponse } from './model/response/user/user';
import { LoginService } from './features/login/login.service';
import { L10n, setCulture } from '@syncfusion/ej2-base';
import * as EJ2_LOCALE from '@syncfusion/ej2-locale/src/it.json';
import { HubService } from './services/web-socket/hub.service';
import { AuthService } from './services/auth.service';
import * as moduleActions from '../app/store/modules/modules.actions'
import { SessionService } from './services/session.service';
import { LanguagesService } from './services/languages/languages.service';
import { LanguagesMapper } from './model/languages/languages-mapper';
import { ToastService } from './core/toast/toast.service';
import { BrowserDetectorService } from './services/browser-detector.service';
import { SideBarService } from './features/sidebar/sidebar.service';
import { ModuleBaseResponse } from './model/response/modules/modules-menu';
import { OfflineDataUpdateService } from './services/offline-data-update.service';
import { Subject, take, takeUntil } from 'rxjs';
import { RolesResponse } from './model/roles';
import { GlobalService } from './services/global.service';
import { BaseResponse } from './model/response/base-response';
import { SidebarComponent } from './features/sidebar/sidebar.component';
import { trigger, style, transition, animate } from '@angular/animations';
import { SettingsService } from './features/settings/settings.service';
import { AppGlobalSettings } from './features/settings/settings';
import { OcrService } from './features/nxt-ocr/ocr.service';
import { ErroriService } from './features/scansione-errori/errori.service';

export declare var navigator: any;


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    SidebarComponent,
  ], animations: [
    trigger('themeChangeOpacity', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ opacity: 0 }))
      ])

    ]),
    trigger('themeChange', [
      transition('false => true', [
        style({ 'background': 'transparent' }),
        animate('500ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ 'background': '#000' }))]),
      transition('true => false', [
        style({ 'background': 'transparent' }),
        animate('500ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ 'background': '#fff' }))])
    ]),


  ]
})

export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  title: string = environment.appName;
  showLoader: boolean = false;
  textReady: boolean = false;
  loaderLogo: string = `${environment.baseHREF}${environment.logo}`
  networkStatus: boolean = true; //true = online  false = offline
  showFetchPopup: boolean = false;
  reloading: boolean = false;
  ignoreButton: boolean = false;
  theEnd$: Subject<void> = new Subject<void>();
  themeReady: boolean = false;
  triggerAnimation: boolean = false;
  dark: boolean = false;


  cssPath: string = environment.theme.darkThemePath;

  constructor(public pwaService: PwaService,
    private store: Store<AppState>,
    private idbService: IdbService,
    private sidebarService: SideBarService,
    private userService: LoginService,
    private authService: AuthService,
    private localStorageService: LocalStorageService,
    private hub: HubService,
    private sessionService: SessionService,
    private languagesSerivce: LanguagesService,
    private browserD: BrowserDetectorService,
    private globalService: GlobalService,
    private settingsService: SettingsService,
    private ocr: ErroriService,
  ) {

    // regiser locale IT as default
    this.sessionService.registerCulture('it-IT');

    /**
     * Imposto i dati in italiano per syncfusion (testi, valute, data, ecc...)
     */
    //console.log((EJ2_LOCALE as any).default.it);
    L10n.load({ it: (EJ2_LOCALE as any).default.it });
    //setCurrencyCode('EUR');
    setCulture("it");

    //checks if the device is offline every 5 seconds
    window.setInterval(() => {
      if (navigator.connection) {
        if (navigator.connection.downlink >= 1) {
          this.browserD.connectionStatus$.next(true);
        } else {
          if (navigator.connection.effectiveType == '4g' || navigator.connection.effectiveType == '3g') {
            this.browserD.connectionStatus$.next(true);
          } else {
            this.browserD.connectionStatus$.next(false);
          }
        }
      }
    }, 5000);

    //IDB CONNECTION
    if (environment.idbOptions)
      this.idbService.connectToIDB(environment.idbOptions.name, environment.idbOptions.items, environment.idbOptions.version);

    //spinner
    this.store.select('spinner', 'item').subscribe(spinner => {
      this.showLoader = spinner.visible;
      // forza parsing di angular
      //console.log(spinner);
      //spinner.visible !== this.showLoader ? this.changeDetectorRef.detectChanges(): this.showLoader = false;
    });

    //CUSTOM COLORS GENERATOR FOR THEME
    this.globalService.themeColors();

    //get session
    let session = localStorageService.getSession();
    
    
    //REFRESH MODULES TO MATCH WITH DATABASE
    if (session != null) {
      this.userService.getUserDatastring(session?.id || 0).pipe(takeUntil(this.theEnd$)).subscribe({
        next: (risp: UserDataStringResponse) => {
          console.log(risp);
          if (risp != null) {
            this.store.dispatch(new userActions.Login({
              userId: risp.user.userId,
              username: risp.user.username,
              roles: risp.user.roles,
              rolesId: risp.user.rolesId,
              filiali: risp.user.filiali,
              password: risp.user.password,
              creationDate: risp.user.creationDate,
              email: risp.user.email,
              surname: risp.user.surname,
              active: risp.user.active,
              authorized: risp.user.authorized,
              checking: false,
              neverLogged: false,
            }));
          }
        }
      });
      this.sidebarService.getAllModules(session.id).pipe(take(1)).subscribe({
        next: (value: ModuleBaseResponse) => {
          localStorage.setItem('M', this.localStorageService.encrypt(JSON.stringify(value.menu)))
          this.localStorageService.menuReady$.next(true);
        }
      })

      this.authService.getModulesRoute(session.id).pipe(take(1)).subscribe({
        next: (dataApi: RolesResponse[]) => {
          //console.warn("This is data API");
          console.warn(dataApi);

          // save the data in the store
          store.dispatch(new moduleActions.GetRoutes({
            route: dataApi,
          }));

        },
        error: (response: any) => {
          console.error("Cannot get the user data right now");
          //return router.navigate(['/error']);
        }
      });
    }

    // set the languages text
    this.languagesSerivce.GetLanguages().subscribe({
      next: (data: LanguagesMapper) => {
        // now that we have the data, set them in a local variable to use them
        this.languagesSerivce.setTexts(data);
        // done
        console.log("Translations loaded");
        this.textReady = true;
      },
      error: (e: any) => {
        console.error("Can't access the trasnslations file, the applications won't start without it!!");

      }
    });

    //block scroll when opening sidebar or when you need it

    this.globalService.blockScroll.pipe(takeUntil(this.theEnd$)).subscribe({
      next: (block: boolean) => {
        console.log(block)

        if (block == false) {
          console.log('ITS OPEN')
          document.getElementById('global-content-container')?.classList.add('overflow-hidden', 'fixed', 'w-screen')
        } else {
          console.log('ITS CLOSED')
          document.getElementById('global-content-container')?.classList.remove('overflow-hidden', 'fixed', 'w-screen')
        }


      }
    })


  }


  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    //this.barcodeWidth =

    if (window.innerHeight > window.innerWidth) {
      this.globalService.isMobile$.next(true);
    } else {
      this.globalService.isMobile$.next(false);
    }
  }

  ngOnDestroy(): void {
    this.theEnd$.unsubscribe();
  }

  themeReturn(): string {
    return this.cssPath;
  }

  ngOnInit(): void {
    // creo connessione con websocket
    this.hub.startConnection();
    this.hub.getTestData();
    this.hub.getUserState();

    // update app settings
    if(this.localStorageService.getSession() != null){
      this.updateLocalAppSettings();

    }

    this.ocr.OCR('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAACNElEQVR4nO3dMQ0AAAgDINc/9K3hHBwwm0gS3zYsBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEDAf4FTGfHKz+30AAAAASUVORK5CYII=')
    .subscribe({
      next: () => {
        console.log('ocr done');
      },
      error: () => {
        console.log('ocr not done');
      }
    })


  }

  updateLocalAppSettings() {

    // check if settings exist in the idb
    this.idbService.getAllData(environment.idbTables.GlobalSettings).then((res: any) => {
      console.warn("\n \n \n GOT THE DATA FROM IDB FOR SETTINGS \n \n \n");
      console.warn(res);

      if (res != undefined) {
        let resData: Array<any> = res;
        if (resData.length == 0) {

          this.settingsService.GetSettings().pipe(takeUntil(this.theEnd$)).subscribe({
            next: (res: AppGlobalSettings) => {

              if (res != undefined) {

                // update or create settings in local idb
                this.idbService.addItemRow(environment.idbTables.GlobalSettings, res, environment.idbTables.GlobalSettings);

              } else {
                console.error("\n \n \n \n \n SHIT \n THERE ARE NO SETTINGS 💀💀💀💀💀💀💀💀💀💀💀💀💀💀 \n \n \n \n \n");
              }

            },
            error: () => {

            }
          });

        } else {
          console.info("SETTINGS ARE SETTED lol");
        }
      }

    });



  }

  //code for animation on theme change
  setDarkMode() {

    this.themeReady = false;

    switch (this.localStorageService.getAppTheme()) {
      case 'dark': {
        this.globalService.dark(true);
        this.dark = true;
        break;
      };
      case 'light': {
        this.globalService.dark(false);
        this.dark = false;
        break;
      };
      case 'system': {
        this.globalService.dark(this.globalService.isDark());
        this.dark = this.globalService.isDark();
        break;
      };
      default: {
        this.localStorageService.setAppTheme('light');
        this.globalService.dark(false);
        this.dark = false;
      }
    }



    if (this.triggerAnimation == true) { // prevents animation on first load 
      setTimeout(() => {
        this.themeReady = true;
      }, 1000);
    } else {
      this.themeReady = true;
    }
  }


  ngAfterViewInit(): void {



    this.globalService.imageChange.pipe(takeUntil(this.theEnd$)).subscribe({
      next: (val: string) => {
        setTimeout(() => {
          if (val == environment.logoDark) {
            this.dark = true;
          } else {
            this.dark = false;
          }
        }, 100);

        this.themeReady = false;
        setTimeout(() => {
          this.themeReady = true;
        }, 1000);
      }
    })

    const darkModePreference = window.matchMedia("(prefers-color-scheme: dark)");
    darkModePreference.addEventListener("change", e => this.setDarkMode());
    this.setDarkMode()
    this.triggerAnimation = true // prevents animation on first load 


    console.error("\n INIZIO CONTROLLO SU VERSIONE \n");

    this.globalService.getAppInfoAndClearCache(environment.version).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (res: BaseResponse) => {
        console.error("\n this is the response \n");
        console.error(res);
        if (res.error != environment.version) {
          this.reloading = true;
          let refreshed = this.localStorageService.getValue('refreshed');
          if (refreshed == 'true') {
            this.ignoreButton = true;
          }
        }
      }
    });

  }


  refreshPage() {

    location.reload();

  }


}
